<template>
  <div v-if="subCompanies.length > 0" class="company-guide-sub-companies">
    <div class="company-guide-section company-guide-bg-support--lighter">
      <h3 v-t="'titles.subsidiaries'"></h3>
      <List :companies="subCompanies" @showDetail="showDetail" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

import List from '../List/List';

export default defineComponent({
  components: { List },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters('companies', {
      subCompanies: 'getSubCompanies',
    }),
  },
  methods: {
    showDetail(companyId: number) {
      this.$store.dispatch('companies/addActiveCompany', companyId);
      this.scrollToTop();
    },
    scrollToTop(): void {
      window.scrollTo(0, 0);
    },
  },
});
</script>
